import * as React from "react";

const SvgMaster = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.275 4.16c-.104-.213-.446-.213-.55 0L8.1 11.535c-.1.206-.427.214-.542.014l-3.99-6.96C3.425 4.342 3 4.432 3 4.71v14.964c0 .146.134.265.3.265h17.4c.166 0 .3-.119.3-.265V4.71c0-.28-.425-.37-.567-.12l-3.99 6.959c-.116.2-.442.192-.543-.014z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMaster;
